import React from 'react'
import { View, Text, StyleSheet } from 'react-native'
import { WebView } from 'react-native-webview'
import client from '@sart/client'
import { adaptive } from '@sart/styles'
import CheckoutLoading from '../Checkout/CheckoutLoading'
import AppConfig from '../Configuration'

class ProfileHostedPayment extends React.Component {
  constructor(props) {
    super(props)
    this.state = { link: null }
  }

  async componentDidMount() {
    const { navigation } = this.props
    //Get the VALIDATE-PAYMENT-CARD product from the catalog
    let tokeniseProducts = await client.callApi('catalog','getTokenizeCardProducts',[client.cache.catalogId])
    const tokeniseProduct = tokeniseProducts.find(
      product => product.productLegacyId === 'VALIDATE-PAYMENT-CARD'
    )
    //set up the basket
    let basket = await client.createBasket()
    basket = await client.addCustomerProductToBasket(basket,tokeniseProduct)
    basket = await client.confirmBasket(basket)
    basket = await client.payForBasketWithHostedPayment(basket)

    this.setState({
      link: basket.gatewayURL,
    })
    await this.checkPaymentStatus(basket.basketRefId)
  }

  async checkPaymentStatus(basketRefId) {
    const { navigation } = this.props
    let order = await client.getOrders(basketRefId, AppConfig.pollingMaxRetries)
    if (!order || order.status ==='failed'){
      navigation.navigate('Checkout', {
        failedOrder: order
      })
    } else {
      console.log('successful');
      var cardToken = JSON.parse(order.paymentAuthorization.tokenDetails)
      navigation.navigate('ProfilePaymentProcessing',{orderRefId: order.orderRefId, cardToken})
    }
  }

  render() {
    const { link } = this.state

    return (
      <View style={styles.container}>
        { !link &&
          <CheckoutLoading />
        }
        <WebView
          source={{ uri: link }}
          style={styles.webview}
          keyboardDisplayRequiresUserAction={false}
          hideKeyboardAccessoryView={true}
        />
      </View>
    )
  }
}

const styles = StyleSheet.create({
  container: {
    paddingTop: 24,
    flex: 1,
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  webview: {
    // marginTop: 10,
    maxHeight: 800,
    ...adaptive.webViewWidth,
    flex: 1
  }
})

export default ProfileHostedPayment

